
import React, { ReactNode } from "react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { LucideIcon } from "lucide-react";

interface ServiceFeatureCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
}

export const ServiceFeatureCard: React.FC<ServiceFeatureCardProps> = ({
  icon: Icon,
  title,
  description,
}) => {
  return (
    <Card className="border-l-4 border-l-dental-highlight transition-all duration-300 hover:shadow-lg hover:-translate-y-1">
      <CardHeader className="pb-2">
        <div className="w-12 h-12 rounded-full bg-dental-highlight/10 flex items-center justify-center mb-2">
          <Icon className="w-6 h-6 text-dental-highlight" />
        </div>
        <CardTitle className="text-xl">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-dental-muted">{description}</p>
      </CardContent>
    </Card>
  );
};
